import { Provider, useSelector } from "react-redux";

// project imports
import { store } from "store";
import theme from "themes";
import NavigationScroll from "layout/NavigationScroll";
import MainLayout from "layout/MainLayout";

// material-ui
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Dashboard from "routes/dashboard/default";
import SamplePage from "routes/sample-page";
import Login from "routes/pages/login/Login3";
import BanksList from "routes/pages/banks/BanksList";
import BankAnnualDataList from "routes/pages/banks/BankAnnualDataList";
import CitiesList from "routes/pages/cities/CitiesList";
import NeighborhoodsList from "routes/pages/neighborhoods/NeighborhoodsList";
import StreetsList from "routes/pages/streets/StreetsList";
import CustomersList from "routes/pages/customers/CustomersList";
import ContractTypesList from "routes/pages/contract-types/ContractTypesList";
import ConstractsList from "routes/pages/contracts/ContractsList";
import LawyersList from "routes/pages/lawyers/LawyersList";
import SalesConsultantsList from "routes/pages/sales-consultants/SalesConsultantsList";
import MaritalStatusList from "routes/pages/marital-status/MaritalStatusList";
import ProfessionsList from "routes/pages/professions/ProfessionsList";
import UsersList from "routes/pages/users/UsersList";
import UserProfilesList from "routes/pages/user-profiles/UserProfilesList";
import GoogleDrivePage from "routes/pages/google-drive/GoogleDrivePage";
import DashboardsPage from "routes/pages/dashboards/DashboardsPage";
import DownloadLogList from "routes/pages/audit/DownloadLogList";
import CommissionsReport from "routes/pages/reports/CommissionsReport";
import AttendancesList from "routes/pages/attendances/AttendancesList";

// ================================|| APP ||================================ //

export default function App() {
  return (
    <Provider store={store}>
      <Free />
    </Provider>
  );
}

export const Free = () => {
  const customization = useSelector((state) => state.customization);
  return (
    <StyledEngineProvider injectfirst>
      <ThemeProvider theme={theme(customization)}>
        <CssBaseline />
        <BrowserRouter>
          <NavigationScroll>
            <Routes>
              <Route index element={<MainLayout component={DashboardsPage} />} />
              <Route
                path="dashboard2"
                element={<MainLayout component={Dashboard} />}
              />
              <Route
                path="sample"
                element={<MainLayout component={SamplePage} />}
              />
              <Route path="login" element={<Login />} />
              <Route
                path="banks/list"
                element={<MainLayout component={BanksList} />}
              />
              <Route
                path="banks/annual-data/list"
                element={<MainLayout component={BankAnnualDataList} />}
              />
              <Route
                path="cities/list"
                element={<MainLayout component={CitiesList} />}
              />
              <Route
                path="neighborhoods/list"
                element={<MainLayout component={NeighborhoodsList} />}
              />
              <Route
                path="streets/list"
                element={<MainLayout component={StreetsList} />}
              />
              <Route
                path="customers/list"
                element={<MainLayout component={CustomersList} />}
              />
              <Route
                path="contract-types/list"
                element={<MainLayout component={ContractTypesList} />}
              />
              <Route
                path="contracts/list"
                element={<MainLayout component={ConstractsList} />}
              />
              <Route
                path="lawyers/list"
                element={<MainLayout component={LawyersList} />}
              />
              <Route
                path="sales_consultants/list"
                element={<MainLayout component={SalesConsultantsList} />}
              />
              <Route
                path="marital-status/list"
                element={<MainLayout component={MaritalStatusList} />}
              />
              <Route
                path="professions/list"
                element={<MainLayout component={ProfessionsList} />}
              />
              <Route
                path="users/list"
                element={<MainLayout component={UsersList} />}
              />
              <Route
                path="user-profiles/list"
                element={<MainLayout component={UserProfilesList} />}
              />
              <Route
                path="google-drive"
                element={<MainLayout component={GoogleDrivePage} />}
              />
              <Route
                path="audit/download-logs"
                element={<MainLayout component={DownloadLogList} />}
              />
              <Route
                path="reports/comissoes"
                element={<MainLayout component={CommissionsReport} />}
              />
              <Route
                path="attendances/list"
                element={<MainLayout component={AttendancesList} />}
              />
            </Routes>
          </NavigationScroll>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
